import { BorderColor } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from '@/components';
import { Modals, Routes } from '@/constants';
import { playerActions, uiActions } from '@/store';
import { Referrer } from '@/types';
import { createRouteWithParams } from '@/utils';

export const QuizReadyTag = ({
  episodeId,
  chapterId,
  referrer,
}: {
  episodeId: string;
  chapterId: string;
  referrer: Referrer;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  return (
    <Box sx={{ '> button': { borderRadius: '20px' } }}>
      <Button
        startIcon={<BorderColor />}
        onClick={() => {
          dispatch(playerActions.setExpanded(false));

          dispatch(
            uiActions.setActiveModal({
              name: Modals.CHAPTER_QUIZ,
              params: {
                episodeId,
                showFirstIncompleteQuiz: true,
              },
            }),
          );

          const route = createRouteWithParams(Routes.EPISODE, { episodeId });
          if (location.pathname === route) return;
          navigate(route, {
            state: {
              referrer,
              activeQuizChapterId: chapterId,
            },
          });
        }}
        label="Quiz Ready!"
        variant="secondary"
      />
    </Box>
  );
};
